import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import BlogBottomForm from '~root/./src/components/BlogBottomForm.vue?shadow'
window.customElements.define('azati-vwc-blog-bottom-form', wrap(Vue, BlogBottomForm))

import ContactUsForm from '~root/./src/components/ContactUsForm.vue?shadow'
window.customElements.define('azati-vwc-contact-us-form', wrap(Vue, ContactUsForm))

import CookieBanner from '~root/./src/components/CookieBanner.vue?shadow'
window.customElements.define('azati-vwc-cookie-banner', wrap(Vue, CookieBanner))

import OurClients from '~root/./src/components/OurClients.vue?shadow'
window.customElements.define('azati-vwc-our-clients', wrap(Vue, OurClients))

import ShortRecruitmentForm from '~root/./src/components/ShortRecruitmentForm.vue?shadow'
window.customElements.define('azati-vwc-short-recruitment-form', wrap(Vue, ShortRecruitmentForm))